import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'antd';
import { downloadAssetsByTiers } from './tierExportDownload';

export default function AssetsByTiersDownloadButton() {
  const request = useRef<AbortController>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => () => request.current?.abort(), []);

  const download = async () => {
    if (request.current) return;
    const controller = new AbortController();
    request.current = controller;
    setLoading(true);
    setError('');
    try {
      await downloadAssetsByTiers(controller.signal);
    } catch (reason) {
      if (!controller.signal.aborted)
        setError('Could not download assets by tiers. Please try again.');
    } finally {
      request.current = undefined;
      if (!controller.signal.aborted) setLoading(false);
    }
  };

  return (
    <>
      <Button
        size="small"
        loading={loading}
        disabled={loading}
        onClick={download}
      >
        Download assets by tiers
      </Button>
      {error && <span role="alert">{error}</span>}
    </>
  );
}
